import React from 'react';
import AnimatedSection from './AnimatedSection';

export default function Contact() {
  return (
    <AnimatedSection id="contact" className="text-center max-w-2xl mx-auto !min-h-[50vh]">
        <h2 className="font-mono text-lg text-teal-300 mb-2">07. What’s Next?</h2>
        <h3 className="text-4xl md:text-5xl font-bold text-slate-100 mb-4">Get In Touch</h3>
        <p className="text-slate-400 mb-8">
            I'm always open to new opportunities and collaborations. Whether you have a question or just want to say hi, my inbox is always open. I’ll do my best to get back to you!
        </p>
        <a 
          href="https://mail.google.com/mail/?view=cm&fs=1&to=ashwinsri04@gmail.com"
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-block text-teal-300 px-8 py-4 rounded-md text-lg font-mono transition-all duration-300 hover:shadow-[0_0_24px_rgba(45,212,191,0.3)]" style={{ border:'1px solid rgba(45,212,191,0.45)', background:'rgba(45,212,191,0.05)' }}
        >
          Say Hello
        </a>

    </AnimatedSection>
  );
}
